var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("admin-offer-expandable-panel"),
      _vm.data !== null
        ? _c(
            "order-details-for-order-item",
            { attrs: { data: _vm.data } },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "mx-0",
                                  attrs: {
                                    to:
                                      "/admin/travel-service/edit/" +
                                      _vm.data.id,
                                    icon: "",
                                    small: ""
                                  }
                                },
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("fa-file-invoice")
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    676312070
                  )
                },
                [_vm._v(" " + _vm._s(_vm.$t("travelService.goToOrder")) + " ")]
              )
            ],
            1
          )
        : _vm._e(),
      _c("order-item-parameters", {
        attrs: { type: _vm.type, "order-item": _vm.data.orderItem }
      }),
      _c(
        "v-row",
        { staticClass: "mb-2" },
        [
          _c(
            "v-col",
            { attrs: { cols: "10" } },
            [
              _c(
                "v-alert",
                { attrs: { color: "error darken-4", outlined: "" } },
                [
                  _vm._v(
                    " Jeśli z jakiegoś powodu oferta przestała być aktualna lub wymagane są dodatkowe dane od klienta niezbędne do rezerwacji możesz zadać dodatkowe pytanie zamawiającemu. Aby to zrobić kliknij ikonę wiadomości po prawej stronie. "
                  ),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      " Funkcjonalność ta powinna być wykorzystywana jedynie w przypadku gdy nie da się zarezerwować przedstawionej oferty. "
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pa-4",
              staticStyle: { "text-align": "center" },
              attrs: { cols: "2" }
            },
            [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.isMessagesEnabled = true
                    }
                  }
                },
                [_c("v-icon", { attrs: { size: "80" } }, [_vm._v("email")])],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.isMessagesEnabled || _vm.data.messages.length > 0
        ? _c("message-list", {
            staticClass: "mb-3",
            attrs: {
              "travel-service-order-id": _vm.data.id,
              "travel-service-order-item-id": _vm.data.orderItem.id,
              "start-messages": _vm.data.messages
            }
          })
        : _vm._e(),
      _c("h2", [_vm._v("Wybrana oferta")]),
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.isValid,
            callback: function($$v) {
              _vm.isValid = $$v
            },
            expression: "isValid"
          }
        },
        [
          _c(
            "offer-item-form",
            {
              attrs: {
                "service-offer": _vm.serviceOffer,
                "is-baggage-field-required": _vm.isBaggageFieldRequired,
                type: _vm.type
              },
              on: {
                "update:serviceOffer": function($event) {
                  _vm.serviceOffer = $event
                },
                "update:service-offer": function($event) {
                  _vm.serviceOffer = $event
                }
              }
            },
            [
              _c("amount-input", {
                attrs: {
                  model: _vm.serviceOffer.price,
                  rules: [_vm.isRequired],
                  label: "Cena łącznie*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                on: {
                  "update:model": function($event) {
                    return _vm.$set(_vm.serviceOffer, "price", $event)
                  }
                }
              }),
              _c("currency-select", {
                attrs: {
                  model: _vm.serviceOffer.currency,
                  rules: [_vm.isRequired],
                  label: "Waluta*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                on: {
                  "update:model": function($event) {
                    return _vm.$set(_vm.serviceOffer, "currency", $event)
                  }
                }
              }),
              _c("ajax-file", {
                attrs: {
                  assign_id: _vm.serviceOffer.id,
                  items: _vm.serviceOffer.files,
                  assign_shortcut: "travelServiceOrderItemResponseOptions",
                  outlined: true,
                  "background-color": "blue lighten-5"
                },
                on: {
                  "update:items": function($event) {
                    return _vm.$set(_vm.serviceOffer, "files", $event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.serviceOffer.travel_service_offer_changes_behavior ===
        _vm.changeAcceptanceType.INFORM_AFTER_CHANGE &&
      !_vm.$store.state.AdminTravelService.isOfferReadonly
        ? _c(
            "v-alert",
            { attrs: { value: true, outlined: "", color: "error darken-3" } },
            [
              _vm._v(" Ten klient "),
              _c("b", [_vm._v("będzie informowany o każdej zmianie")]),
              _vm._v(
                " w ofercie po jej zapisaniu i wysłaniu. Sprawdź czy uzupełniłeś wszystkie dane i czy są one poprawne. Będziesz mógł jedynie załączyć plik z rezerwacją. "
              )
            ]
          )
        : _vm._e(),
      _vm.serviceOffer.travel_service_offer_changes_behavior ===
        _vm.changeAcceptanceType.ACCEPTANCE_NEEDED &&
      !_vm.$store.state.AdminTravelService.isOfferReadonly
        ? _c(
            "v-alert",
            { attrs: { value: true, outlined: "", color: "error darken-3" } },
            [
              _vm._v(" Każda zmiana w ofercie po wybraniu przez tego klienta "),
              _c("b", [_vm._v("musi być ponownie akceptowana")]),
              _vm._v(
                ". Włączyłeś tryb edycji - oferta trafi ponownie do akceptacji. Sprawdź czy uzupełniłeś wszystkie dane i czy są one poprawne. Będziesz mógł jedynie załączyć plik z rezerwacją. "
              )
            ]
          )
        : _vm._e(),
      _c(
        "v-card",
        { attrs: { text: "", flat: "" } },
        [
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel }
                },
                [_vm._v("Anuluj")]
              ),
              _vm.$store.state.AdminTravelService.isOfferReadonly
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.unlockEdit }
                    },
                    [_vm._v(" Odblokuj edycję ")]
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.$store.getters["Ajax/loading"],
                    color: "blue darken-1",
                    text: ""
                  },
                  on: { click: _vm.previewPDF }
                },
                [_vm._v("Podgląd PDF")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.$store.getters["Ajax/loading"],
                    color: "blue darken-1",
                    text: ""
                  },
                  on: { click: _vm.save }
                },
                [_vm._v("Zapisz i wyślij ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("AdminOfferHistory", {
        attrs: { "service-offer": [_vm.serviceOffer] }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }